import React from "react";

/** Generic shimmering skeleton block. */
export function Skeleton({ className = "", style }) {
  return (
    <div
      className={`relative overflow-hidden rounded-md bg-white/[0.04] ${className}`}
      style={style}
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(110deg, transparent 30%, rgba(255,255,255,0.08) 50%, transparent 70%)",
          animation: "sweep 1.4s linear infinite",
        }}
      />
    </div>
  );
}

export function ResultsTableSkeleton() {
  return (
    <div className="card-surface p-5" data-testid="results-skeleton">
      <Skeleton className="h-4 w-24 mb-3" />
      <Skeleton className="h-6 w-40 mb-5" />
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="flex items-center justify-between gap-3 py-3 border-t border-white/5">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-12" />
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-3 w-10" />
          <Skeleton className="h-3 w-14" />
          <Skeleton className="h-3 w-24" />
        </div>
      ))}
    </div>
  );
}

export function ChartSkeleton() {
  return (
    <div className="card-surface p-5" data-testid="chart-skeleton">
      <div className="flex items-start justify-between mb-4">
        <div className="space-y-2">
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-3 w-32" />
        </div>
        <Skeleton className="h-8 w-20" />
      </div>
      <Skeleton className="h-[200px] w-full" />
    </div>
  );
}
